import { render, staticRenderFns } from "./VehicleGeneration.vue?vue&type=template&id=b08d795e&"
import script from "./VehicleGeneration.vue?vue&type=script&lang=js&"
export * from "./VehicleGeneration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports